import { hotkeyPrefix } from '@shared/constants/CommandValues';
import EditProfileContainer from '@shared/hooks/state/EditProfileContainer';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import ContentDialog from '../core/dialog/ContentDialog';
import { BodyMedium } from '../core/text/Typography';

const DeprecatedHotkeyDialog: React.FC = () => {
    const { t } = useTranslation();
    const editProfileContainer = EditProfileContainer.useContainer();
    const navigate = useNavigate();
    const onConfirm = async () => {
        editProfileContainer.hotkeys.forEach((hotkey) => {
            // eslint-disable-next-line @typescript-eslint/no-unused-expressions
            hotkey.command.startsWith(hotkeyPrefix)
                ? null
                : editProfileContainer.updateDeprecatedHotkey(hotkey, editProfileContainer.macros);
        });
        const result = await editProfileContainer.saveChanges();
        if (result?.resultType == 'Ok') {
            editProfileContainer.setIsDeprecatedHotkey(false);
            navigate(`/profiles/edit/${result?.data?.id}`, { replace: true });
        }
        editProfileContainer.setIsDeprecatedHotkey(false);
    };
    return (
        <ContentDialog
            open={editProfileContainer.isDeprecatedHotkey}
            onClose={onConfirm}
            description={t('common:hotkey.deprecatedDialog.description1')}
            title={t('common:hotkey.deprecatedDialog.title')}
            onConfirm={onConfirm}
            confirmButtonText={t('common:hotkey.deprecatedDialog.confirm')}>
            <BodyMedium>{t('common:hotkey.deprecatedDialog.description2')}</BodyMedium>
        </ContentDialog>
    );
};

export default DeprecatedHotkeyDialog;
